<ng-container *ngIf="selectedProperty$ | async as selectedProperty">
  <app-habitation-page-container>
    <div class="page-content">
      <h1 appFocusOnInit class="titre-page">{{ 'propriete.detail.titre' | translate }}</h1>
      <div class="payments-photo-row">
        <div class="property-details-payments-container">
          <app-property-details-payments
            [currentProperty]="getProperty(selectedProperty)"
          ></app-property-details-payments>
        </div>
        <div *featureToggle="MPM_PROPRIETE_PHOTO_ENABLED.On" class="property-details-photo-container">
          <app-property-details-photo [currentProperty]="selectedProperty"></app-property-details-photo>
        </div>
      </div>
      <div class="illustration-row" [ngClass]="{ side: hasNoDepensesDettes(selectedProperty) }">
        <div class="property-details-add-depenses-container" *ngIf="hasNoDepensesDettes(selectedProperty)">
          <app-property-details-add-depenses
            [propertyId]="selectedProperty.id"
            [hasDepenses]="totalDepensesSelonIndicateur !== 0"
            [hasDettes]="totalEngagements !== 0"
          >
          </app-property-details-add-depenses>
        </div>
        <div
          class="property-details-illustration-container"
          [ngClass]="{ side: hasNoDepensesDettes(selectedProperty) }"
        >
          <app-property-details-illustration
            [hasSmallImage]="hasNoDepensesDettes(selectedProperty)"
            [isIndicateurRisqueMoyenHaut]="isIndicateurRisqueMoyenHaut(selectedProperty)"
          >
          </app-property-details-illustration>
        </div>
      </div>
      <div class="property-details-fees-container">
        <app-property-details-fees [currentProperty]="getProperty(selectedProperty)"></app-property-details-fees>
      </div>
      <div *ngIf="getProperty(selectedProperty).isOldPropriete" class="property-details-old-info-container">
        <app-property-details-old-info [currentProperty]="selectedProperty"></app-property-details-old-info>
      </div>
      <hr class="property-detail-divider" />
      <p class="property-detail-text">
        <strong [innerHTML]="'propriete.detail.estimer-paiement' | translate"></strong>
      </p>
      <div class="property-details-action">
        <button mat-button class="property-add  white" type="button" (click)="createProperty()">
          {{ 'propriete.liste.btn-ajouter' | translate }}
        </button>
      </div>
      <button mat-button class=" button-back no-border" id="btn-rtn-accueil" (click)="navigateBackHome()">
        <img src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}" alt="" class="button-icone-left" />
        {{ 'btn.retour-accueil' | translate }}
      </button>
    </div>
  </app-habitation-page-container>
  <app-sub-footer [enableNextStep]="true" [nextStep]="'preauth'"></app-sub-footer>
</ng-container>
